// extracted by css-extract-rspack-plugin
module.exports =  {"trending_slider":"drn37","sliderHeading":"OCIcF","sliderItemHeading":"Ug4u8","trending_sliderContent":"qIj23","trending_slider_ani":"r9MAa"};